import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'
import CourseSideBarItems from './CourseSideBarItems'
import { Button, Typography } from '@material-ui/core/'
import TopAndBottomBar from '../TopAndBottomBar'
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import CourseTitleBlock from './CourseTitleBlock'
import logo from '../../assets/images/logoNovo.png'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import styled from 'styled-components'
import { userQueries, modulesQueries, coursesQueries } from '../../graphql/queries/'
import { useQuery, useLazyQuery } from '@apollo/react-hooks'
import * as courseUtils from '../../utils/course'
import NavMenu from '../NavMenu'
import { Link as RouterLink } from 'react-router-dom'
import ForumIcon from '@material-ui/icons/Forum'
import OptionsMenu from './OptionsMenu.js'
import FeedbackButtons from './FeedbackButtons'



const useStyles = makeStyles(theme => ({
  list: {
    width: 300
  },
  fullList: {
    width: 'auto'
  },
  mobileContentWrapper: {
    width: '100%',
    height: '100%'
  },
  bottomBar: {
    top: 'unset',
    bottom: 0,
    minHeight: '158px',
    backgroundColor: '#f0f0f7',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    '@media (max-width: 1050px)': {
      maxHeight: '240px',
      height: '100%',
      zIndex: 0
    }
  },
  bottomToolBar: {
    height: '100%',
    backgroundColor: '#f0f0f7',
    '@media (max-width: 1050px)': {
      padding: '0'
    }
  },
  supportButton: {
    backgroundColor: '#3B86FF',
    color: '#fff',
    opacity: '1',
    '&:hover': {
      backgroundColor: '#3B86FF'
    }
  }
}))

const Logo = styled.img`
  max-height: 32px;
  @media (max-width: 1050px) {
    max-height: 24px;
  }
`

const ActionWrapper = styled.div`
  margin: 8px 24px 0;
`

const CourseInfo = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: flex-start;
  flex-direction: column;
  height: 100%;
`

const MobileActionsBar = ({ children, cursoId, courseId, trails, currentContent }) => {
  const classes = useStyles()
  const contentList = courseUtils.getContentsFromTrails(trails)
  const [state, setState] = useState({
    left: false
  })

  const { data: dataCourse } = useQuery(coursesQueries.GET_COURSE, { variables: { id:courseId } })
  
  const [loadModule, { data: dataModule }] = useLazyQuery(modulesQueries.GET_MODULES, { fetchPolicy: 'network-only' })

  useEffect(() => {
    loadModule()
  }, []) //eslint-disable-line

  let forumExist = false

  if (dataModule) {
    const currentCourse = dataModule.modulo.find(item => item.cursos.find(curso => curso === cursoId))
    forumExist = (currentCourse || {}).forum || false
  }

  const { data: dataUser } = useQuery(userQueries.GET_USER)

  const toggleDrawer = (side, open) => event => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }

    setState({ ...state, [side]: open })
  }

  const onClose = side => {
    setState({ ...state, [side]: false })
  }

  let courseTitle = (contentList[contentList.findIndex(e => e._id === currentContent)] || {}).titulo
  let courseTeacher = (contentList[contentList.findIndex(e => e._id === currentContent)] || {}).professor
  let courseType = (contentList[contentList.findIndex(e => e._id === currentContent)] || {}).tipo

  const currentTrailId = (trails || []).reduce((acc, trail) => {
    const find = (trail.items || []).find(trailItem => {
      return (trailItem || {}).conteudos.find(content => {
        return content._id === currentContent
      })
    })
    if (find && !acc) {
      return (find || {})._id
    } else {
      return acc || null
    }
  }, null)

  const sideList = ({ side }) => (
    <div className={classes.list} role="presentation" onKeyDown={toggleDrawer(side, false)}>
      <CourseTitleBlock course={(dataCourse || {}).curso} currentContent={currentContent} trails={trails} />
      <CourseSideBarItems courseId={cursoId}  cronograma={((dataCourse|| {}).curso || {}).cronograma} trails={trails} onClose={() => onClose('left')} currentContent={currentContent} />
    </div>
  )

  return (
    <div className={classes.mobileContentWrapper}>
      <TopAndBottomBar topBar>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <IconButton color="inherit" aria-label="open drawer" onClick={toggleDrawer('left', true)} edge="start">
            <MenuIcon />
          </IconButton>
          <Logo src={logo} />
          <SwipeableDrawer open={state.left} onClose={toggleDrawer('left', false)} onOpen={toggleDrawer('left', true)}>
            {sideList('left')}
          </SwipeableDrawer>
        </div>
        <NavMenu menuIcon="options" courseId={courseId}>
          <OptionsMenu dataUser={dataUser || {}} />
        </NavMenu>
      </TopAndBottomBar>
      {children}
      {courseType === 'video' || courseType === 'leitura' || courseType === 'podcast' ? (
        <AppBar position="fixed" className={classes.bottomBar}>
          <Toolbar className={classes.bottomToolBar}>
            <CourseInfo>
              <ActionWrapper>
                <FeedbackButtons conteudoId={currentContent} cursoId={cursoId} trilhaId={currentTrailId} />
              </ActionWrapper>
              <ActionWrapper>
                <Typography gutterBottom variant="body1" component="h2">
                  Título: {courseTitle}
                </Typography>
                <Typography gutterBottom variant="body1" component="h2">
                  Professor: {courseTeacher}
                </Typography>
              </ActionWrapper>
              <ActionWrapper>
                <Button
                  disabled={!((dataUser || {}).usuario || {}).email}
                  component={'a'}
                  href={`https://atendimento.manole.com.br/aprimora/?e=${btoa(((dataUser || {}).usuario || {}).email)}`}
                  variant="outlined"
                  rel="noopener"
                  target="_blank"
                  style={{ marginRight: '8px' }}
                  className={classes.supportButton}
                  startIcon={<RecordVoiceOverIcon style={{ fontSize: '16px' }} />}
                >
                  Suporte
                </Button>
                {forumExist && (
                  <Button
                    disabled={!currentTrailId}
                    component={RouterLink}
                    variant="outlined"
                    to={`/forum/${cursoId}?categoria=${currentTrailId}`}
                    style={{ marginRight: '8px' }}
                    className={classes.supportButton}
                    startIcon={<ForumIcon style={{ fontSize: '16px' }} />}
                  >
                    Fórum
                  </Button>
                )}
              </ActionWrapper>
            </CourseInfo>
          </Toolbar>
        </AppBar>
      ) : (
        ''
      )}
    </div>
  )
}

export default MobileActionsBar
